// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1YZcf","row":"ProcedureTreatmentSummary_row__FUfga"};